import { render, staticRenderFns } from "./workflow-approval-dialog.vue?vue&type=template&id=622e75d2&scoped=true"
import script from "./workflow-approval-dialog.vue?vue&type=script&lang=js"
export * from "./workflow-approval-dialog.vue?vue&type=script&lang=js"
import style0 from "./workflow-approval-dialog.vue?vue&type=style&index=0&id=622e75d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622e75d2",
  null
  
)

export default component.exports